import BaseScenarioPart from "../../../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { getNextPartId } from "../../../../misc/tools";
import { BaseGeneralConfig, GameBaseScenario, GeneralPartConfig } from "../../../GameBaseScenario";
import WcWorkStoppageComponentsStep0Part1 from "./wc-work-stoppage-components-step0-parts/wc-work-stoppage-components-step0-part1";

export default class WcWorkStoppageComponentsStep0Component {
	private _parts: BaseScenarioPart<GameBaseScenario>[] = [];
	private _partId1 = getNextPartId();
	public get parts() {
		return this._parts;
	}
	constructor(public config: WcWorkStoppageComponentsStep0ComponentMainConfig) {
		let context = this;
		context._parts.push(new WcWorkStoppageComponentsStep0Part1(context.config.scenario, () => {
			context.config.onDone();
		}, context._partId1, config));
	}

	public start() {
		this.goToPart1();
	}

	goToPart1() {
		this.config.scenario.loadPart(this._partId1);
	}
}

export interface WcWorkStoppageComponentsStep0ComponentMainConfig extends BaseGeneralConfig {
	scenario: GameBaseScenario;
	part1Config?: WcWorkStoppageComponentsStep0ComponentPart1Config;
	onDone: () => void;
}

export interface WcWorkStoppageComponentsStep0ComponentPart1Config extends GeneralPartConfig {
	chapter: () => string;
}